import { VERSION, COMMIT, fechaLegible } from "../lib/version";

/**
 * «v1.1.0», pequeño y gris. El detalle (fecha y commit) va en el `title`: a quien
 * atiende una llamada le basta el número; el resto es para quien despliega.
 */
export function Version({ className = "app-version" }: { className?: string }) {
  const fecha = fechaLegible();
  const detalle = `Versión ${VERSION}${fecha ? ` · ${fecha}` : ""} · ${COMMIT}`;
  return (
    <small className={className} title={detalle} aria-label={detalle}>
      v{VERSION}
    </small>
  );
}
